import { service } from "../utils/request";

/* 商户 */
//添加商户
export function AddMerchant(data) {
  return service({
    url: "merch/agent.merch/add",
    method: "post",
    data: data
  });
}

//获取行业列表
export function GetIndustry(data) {
  return service({
    url: "merch/agent.merch/industry",
    method: "post",
    data: data
  });
}

//编辑商户
export function EditMerchant(data) {
  return service({
    url: "merch/agent.merch/edit",
    method: "post",
    data: data
  });
}

//商户列表
export function MerchantList(data) {
  return service({
    url: "merch/agent.merch/index",
    method: "post",
    data: data
  });
}

/* 商户分类 */
//商户分类列表
export function ClassList(data) {
  return service({
    url: "merch/agent.merchcate/index",
    method: "post",
    data: data
  });
}

//添加商户分类
export function AddClass(data) {
  return service({
    url: "merch/agent.merchcate/add",
    method: "post",
    data: data
  });
}

//编辑商户分类
export function EditClass(data) {
  return service({
    url: "merch/agent.merchcate/edit",
    method: "post",
    data: data
  });
}

//删除商户分类
export function DelClass(data) {
  return service({
    url: "merch/agent.merchcate/del",
    method: "post",
    data: data
  });
}

/* 商户分组 */
//商户分组列表
export function GroupList(data) {
  return service({
    url: "merch/agent.merchgroup/index",
    method: "post",
    data: data
  });
}

//添加商户分组
export function AddGroup(data) {
  return service({
    url: "merch/agent.merchgroup/add",
    method: "post",
    data: data
  });
}

//编辑商户分组
export function EditGroup(data) {
  return service({
    url: "merch/agent.merchgroup/edit",
    method: "post",
    data: data
  });
}

//删除商户分组
export function DelGroup(data) {
  return service({
    url: "merch/agent.merchgroup/del",
    method: "post",
    data: data
  });
}

/* 商户等级 */
// 添加商户等级
export function AddLevel(data) {
  return service({
    url: "merch/agent.merchlevel/add",
    method: "post",
    data: data
  });
}

// 商户等级列表
export function LevelList(data) {
  return service({
    url: "merch/agent.merchlevel/index",
    method: "post",
    data: data
  });
}

// 编辑商户等级
export function EditLevel(data) {
  return service({
    url: "merch/agent.merchlevel/edit",
    method: "post",
    data: data
  });
}

// 删除商户等级
export function DelLevel(data) {
  return service({
    url: "merch/agent.merchlevel/del",
    method: "post",
    data: data
  });
}

/* 店铺设置 */
// 获取设置
export function MerchSet(data) {
  return service({
    url: "merch/agent.merchsetting/index",
    method: "post",
    data: data
  });
}

// 修改设置
export function EditSet(data) {
  return service({
    url: "merch/agent.merchsetting/edit",
    method: "post",
    data: data
  });
}

/* 商户行业分类 */
// 获取插件列表
export function GetPluginsList(data) {
  return service({
    url: "api/Agentusers/plugins",
    method: "post",
    data: data
  });
}

//行业列表
export function MerchTypeList(data) {
  return service({
    url: "merch/agent.Merchindustry/index",
    method: "post",
    data: data
  });
}

// 添加分类
export function AddMerchType(data) {
  return service({
    url: "merch/agent.Merchindustry/add",
    method: "post",
    data: data
  });
}

// 修改分类
export function EditMerchType(data) {
  return service({
    url: "merch/agent.Merchindustry/edit",
    method: "post",
    data: data
  });
}

//删除分类
export function DelMerchType(data) {
  return service({
    url: "merch/agent.Merchindustry/del",
    method: "post",
    data: data
  });
}

// 分类详情
export function MerchTypeDetail(data) {
  return service({
    url: "merch/agent.Merchindustry/detail",
    method: "post",
    data: data
  });
}
// 积分联盟应用列表
export function getIntegralList(data) {
  return service({
    url: "alliance/agent.index/allianceList",
    method: "post",
    data: data
  });
}

// 解除联盟关系
export function cancelAlliance(data) {
  return service({
    url: "alliance/agent.index/cancelAlliance",
    method: "post",
    data: data
  });
}
// 添加积分联盟油站
export function addAlliance(data) {
  return service({
    url: "alliance/agent.index/addAlliance",
    method: "post",
    data: data
  });
}
// 获取加盟油站列表
export function getLianceList(data) {
  return service({
    url: "alliance/agent.index/allianceSelect",
    method: "post",
    data: data
  });
}
// 获取加盟油站列表
export function getPointLogs(data) {
  return service({
    url: "alliance/agent.index/pointLogs",
    method: "post",
    data: data
  });
}
// 添加联盟时获取应用的id名称
export function getAppMsg(data) {
  return service({
    url: "alliance/agent.index/getAppMsg",
    method: "post",
    data: data
  });
}
// 审核联盟
export function auditAlliance(data) {
  return service({
    url: "alliance/agent.index/auditAlliance",
    method: "post",
    data: data
  });
}
// 联盟商品列表
export function allianceGoods(data) {
  return service({
    url: "creditshop/agent.creditshop_goods/alliance_goods",
    method: "post",
    data: data
  });
}
